// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let AvatarSrcUrl = require("../../../utils/AvatarSrcUrl.bs.js");
let TailwindMerge = require("tailwind-merge");
let JsxRuntime = require("react/jsx-runtime");
let FragmentErrorBoundary = require("./FragmentErrorBoundary.bs.js");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let AgentProfilePhoto_agent_graphql = require("../../../__generated__/AgentProfilePhoto_agent_graphql.bs.js");

let convertFragment = AgentProfilePhoto_agent_graphql.Internal.convertFragment;

function AgentProfilePhoto$Avatar(props) {
  let __className = props.className;
  let __url = props.url;
  let url = __url !== undefined ? __url : AvatarSrcUrl.place_holder;
  let className = __className !== undefined ? __className : "";
  return JsxRuntime.jsx("img", {
    className: TailwindMerge.twMerge([
      "rounded-full w-[60px] h-[60px] object-contain bg-zinc-100",
      className
    ]),
    alt: props.alt,
    src: url
  });
}

let Avatar = {
  make: AgentProfilePhoto$Avatar
};

function AgentProfilePhoto$WithoutErrorBoundary(props) {
  let match = RescriptRelay_Fragment.useFragment(AgentProfilePhoto_agent_graphql.node, convertFragment, props.profilePhoto);
  let agentProfilePhoto = match.agentProfilePhoto;
  let url = agentProfilePhoto !== undefined ? agentProfilePhoto.url : AvatarSrcUrl.place_holder;
  return JsxRuntime.jsx(AgentProfilePhoto$Avatar, {
    alt: match.displayName + `'s profile picture`,
    url: url,
    className: props.className
  });
}

let WithoutErrorBoundary = {
  make: AgentProfilePhoto$WithoutErrorBoundary
};

function AgentProfilePhoto(props) {
  return JsxRuntime.jsx(FragmentErrorBoundary.make, {
    fragmentDisplayName: "agent profile photo",
    children: JsxRuntime.jsx(AgentProfilePhoto$WithoutErrorBoundary, {
      profilePhoto: props.profilePhoto,
      className: props.className
    })
  });
}

let make = AgentProfilePhoto;

exports.Avatar = Avatar;
exports.WithoutErrorBoundary = WithoutErrorBoundary;
exports.make = make;
/* AvatarSrcUrl Not a pure module */
